module.exports = __webpack_public_path__ + "static/media/Sance de travail Orlans BT L.b55bc06d.jpg";